import { AccessibilityOptionDetails } from 'store/accessibility/types';

export enum FONT_SIZE {
  DEFAULT = 'DEFAULT',
  LARGE = 'LARGE',
  EXTRA_LARGE = 'EXTRA_LARGE',
  HUGE = 'HUGE'
}

export const accessibilityOptionsList: Array<AccessibilityOptionDetails> = [
  {
    'data-test': 'contrast-theme-button',
    visible: true,
    fullWidth: true,
    key: 'isContrastTheme',
    description: '[contrast theme description]',
    label: `[contrast theme]`,
    icon: {
      name: 'contrast',
      size: 20
    }
  },
  {
    'data-test': 'readable-font-button',
    key: 'isReadableFont',
    description: `[readable font description]`,
    label: `[readable font]`,
    icon: {
      name: 'readable-font',
      size: 20
    }
  },
  {
    'data-test': 'font-size-adjustment-button',
    key: 'fontSize',
    description: `[font size adjustment description]`,
    label: `[font size adjustment]`,
    fullWidth: true,
    showFontSizeAdjustment: true,
    icon: {
      name: 'font-size',
      size: 20
    }
  },
  {
    'data-test': 'dyslexia-font-button',
    key: 'isDyslexiaFont',
    description: `[dyslexia font description]`,
    label: `[dyslexia font]`,
    icon: {
      name: 'dyslexia',
      size: 20
    }
  },
  {
    'data-test': 'seizure-safe-button',
    key: 'isSeizureSafe',
    description: `[seizure safe description]`,
    label: `[seizure safe]`,
    icon: {
      name: 'seizure-safe',
      size: 20
    }
  }
];
